import { render, staticRenderFns } from "./sidebarL.vue?vue&type=template&id=06e058cd&scoped=true"
import script from "./sidebarL.vue?vue&type=script&lang=js"
export * from "./sidebarL.vue?vue&type=script&lang=js"
import style0 from "./sidebarL.vue?vue&type=style&index=0&id=06e058cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e058cd",
  null
  
)

export default component.exports